var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.2129C0 6.03319 5.8203 0.212891 13 0.212891C20.1797 0.212891 26 6.03319 26 13.2129C26 20.3926 20.1797 26.2129 13 26.2129C5.8203 26.2129 0 20.3926 0 13.2129Z",
    fill: "#F1B434"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1877_2019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 9.87956C12.6337 9.87956 12.3198 9.749 12.0587 9.48789C11.7975 9.22678 11.667 8.91289 11.667 8.54622C11.667 8.17956 11.7975 7.86567 12.0587 7.60456C12.3198 7.34345 12.6337 7.21289 13.0003 7.21289C13.367 7.21289 13.6809 7.34345 13.942 7.60456C14.2031 7.86567 14.3337 8.17956 14.3337 8.54622C14.3337 8.91289 14.2031 9.22678 13.942 9.48789C13.6809 9.749 13.367 9.87956 13.0003 9.87956ZM13.0003 19.2129C12.7225 19.2129 12.4864 19.1157 12.292 18.9212C12.0975 18.7268 12.0003 18.4907 12.0003 18.2129V12.2129C12.0003 11.9351 12.0975 11.699 12.292 11.5046C12.4864 11.3101 12.7225 11.2129 13.0003 11.2129C13.2781 11.2129 13.5142 11.3101 13.7087 11.5046C13.9031 11.699 14.0003 11.9351 14.0003 12.2129V18.2129C14.0003 18.4907 13.9031 18.7268 13.7087 18.9212C13.5142 19.1157 13.2781 19.2129 13.0003 19.2129Z",
    fill: "#DDF8E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1877_2019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(7 7.21289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.4dea3b73cf63e9340cab58ef4c00bf48.svg";
export { ForwardRef as ReactComponent };